import type { ChannelSummary } from '../../interfaces/ICommsApi.js';
import { dmChannelId } from './dmChannelId.js';

/**
 * A DM thread that doesn't exist in the backend yet — same shape as a real
 * `ChannelSummary` so the thread UI renders it identically (header, empty
 * message list, enabled composer). Never sent to the backend on its own; it
 * only exists so the user can open and compose into a DM before anything has
 * been saved. Its id is deterministic (see `dmChannelId`), so the moment the
 * real channel is created — at first send, see `ChatSocketProvider.send` —
 * it has the exact same id and this placeholder becomes redundant with no
 * further bookkeeping required.
 */
export function makeVirtualDmChannel(
  siteId: string,
  currentUserId: string,
  targetUserId: string,
): ChannelSummary {
  return {
    id: dmChannelId(siteId, currentUserId, targetUserId),
    kind: 'dm',
    createdAt: new Date().toISOString(),
    memberCount: 2,
    memberIds: [currentUserId, targetUserId],
  };
}
